import { JsonObject, JsonProperty } from 'json2typescript';
import { CollectionCardRankType } from '../../enums/collections/collection-card-rank-type.enum';

@JsonObject('CollectionBoosterDrop')
export class CollectionBoosterDrop {

  @JsonProperty('card_rank_type', Number)
  cardRankType: CollectionCardRankType = CollectionCardRankType.None;

  @JsonProperty('rarity_weight', Number)
  rarityWeight: number = 0;
}
